import { Radio, Text } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Label = styled(Text)`
    display: inline-block;
    margin-bottom: 0.375rem;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const ValuesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.vui.colors.border.divider.default};
    border-radius: 4px;

    @media ${device.maxMobileL} {
        grid-template-columns: 1fr;
    }
`;

const RadioInput = styled(Radio)`
    height: 3.5rem;
    padding: 0 0.75rem;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};

    &:last-of-type {
        border-left: 1px solid ${({ theme }) => theme.vui.colors.border.divider.default};
    }

    @media ${device.maxMobileL} {
        &:last-of-type {
            border-left: none;
            border-top: 1px solid ${({ theme }) => theme.vui.colors.border.divider.default};
        }
    }
`;

export { Label, ValuesContainer, RadioInput };
